import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6 9C6 6.23858 8.23858 4 11 4H18V6H17V20H15V6H13V20H11V14C8.23858 14 6 11.7614 6 9ZM11 12V6C9.34315 6 8 7.34315 8 9C8 10.6569 9.34315 12 11 12Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Paragraph"
);
